<template>
	<div
		class="mode-selector selector"
		:class="{ missing: !classified.mode && showWarnings }"
	>
		<div class="pa-block">
			<h3 class="selector-title">Support de publication</h3>
			<div class="pa-block__inner">
				<div class="pa-block__col-container">
					<div
						class="pa-block__col inactive"
						:class="{ inactive: mode == 'web', active: mode == 'print_web' }"
					>
						<label for="mode-print_web">
							<img
								src="/wp-content/themes/id/images/classified/illustrations/illustration-annonce-presse-web.png"
								width="160"
								height="90"
								alt=""
							/>
							<strong>Annonce presse + web</strong>
							<ul>
								<li>
									Publication dans l'Information Dentaire<br />
									<small>1ère revue des chirurgiens-dentistes</small>
								</li>
								<li>Mise en ligne sur le site internet</li>
								<li>
									<strong
										>Reprise sur le site internet Abcdent.pro
										<span class="text-primary">NOUVEAU</span></strong
									>
								</li>
							</ul>
							<div class="price">
								<span>
									A partir de {{ price("print_web") }} €
									<small>TTC</small>
								</span>
							</div>
							<input
								type="radio"
								name="mode"
								id="mode-print_web"
								value="print_web"
								v-model="mode"
							/>
						</label>
					</div>
					<!-- .pa-block__col -->
					<div
						class="pa-block__col inactive"
						:class="{ active: mode == 'web', inactive: mode == 'print_web' }"
					>
						<label for="mode-web">
							<img
								src="/wp-content/themes/id/images/classified/illustrations/illustration-annonce-web.png"
								width="130"
								height="90"
								alt=""
							/>
							<strong>Annonce web</strong>
							<ul>
								<li>Publication sur le site internet</li>
								<li v-if="isCurrentCategoryFree">
									<strong>
										Reprise sur le site internet Abcdent.pro
										<span class="text-primary">NOUVEAU</span>
									</strong>
								</li>
							</ul>
							<div class="price">
								<span v-if="price('web') > 0">
									A partir de {{ price("web") }} €
									<small>TTC</small>
								</span>
								<span v-else>
									Gratuit
									<!-- <br />
                  <small>Pour les demandes d'emploi</small> -->
								</span>
							</div>

							<input
								type="radio"
								name="mode"
								id="mode-web"
								value="web"
								v-model="mode"
							/>
						</label>
					</div>
					<!-- .pa-block__col -->
				</div>
				<!-- .pa-block__col-container -->
				<div class="required" :if="!classified.mode">Champ non renseigné</div>
			</div>

			<!-- .pa-block__inner -->
		</div>
		<!-- .pa-block -->
	</div>
	<!-- .mode-selector -->
</template>
<script>
import { mapState, mapGetters } from "vuex";

export default {
	name: "mode-selector",
	props: {
		showWarnings: {
			type: Boolean,
			default: false,
		},
	},
	data: function () {
		return {};
	},
	computed: {
		...mapGetters([
			"currentCategory",
			"getSettings",
			"getPreset",
			"isCurrentCategoryFree",
		]),
		...mapState(["classified"]),

		mode: {
			get() {
				return this.$store.state.classified.mode;
			},
			set(mode) {
				this.$store.commit("setMode", mode);
			},
		},
	},
	created() {
		if (!this.classified.mode && this.getPreset.mode)
			this.$store.commit("setMode", this.getPreset.mode);
	},
	methods: {
		price(mode) {
			if (mode == "web") {
				if (this.$store.state.classified.profil == "proflib") {
					let category = this.$store.state.categories.find(
						(cat) => cat.term_id == this.currentCategory
					);

					if (category.free_category) {
						return 0;
					} else {
						return parseInt(this.getSettings.formats.proflib.web.simple);
					}
				}
				if (this.$store.state.classified.profil == "recruiter") {
					return parseInt(this.getSettings.formats.recruiter.web.simple);
				}
			}
			if (mode == "print_web") {
				if (this.$store.state.classified.profil == "proflib") {
					return parseInt(this.getSettings.formats.proflib.print_web["simple"]);
				}
				if (this.$store.state.classified.profil == "recruiter") {
					return parseInt(this.getSettings.formats.recruiter.print_web["1/9"]);
				}
			}
		},
	},
};
</script>
